const calculateDiscountedPrice = (price, discount) => Math.ceil(price - (price * discount) / 100);

export { calculateDiscountedPrice };